/* ============================================================
   PONTO D — COMPARADOR DE PRODUTOS
   Smartphones + Equipamentos Básicos
   ============================================================ */

(function () {
  'use strict';

  /* Evita inicialização duplicada caso o asset seja carregado
     por mais do que uma secção de produtos. */
  if (window.PontoDComparatorLoaded) return;
  window.PontoDComparatorLoaded = true;

  const STORAGE_KEY = 'pd-product-comparator-v1';
  const MAX_PRODUCTS = 4;

  let selected = [];

  /* ==========================================================
     HELPERS
     ========================================================== */

  function safeParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function loadSelection() {
    selected = safeParse(localStorage.getItem(STORAGE_KEY), []);

    if (!Array.isArray(selected)) {
      selected = [];
    }

    if (selected.length > MAX_PRODUCTS) {
      selected = selected.slice(0, MAX_PRODUCTS);
      saveSelection();
    }
  }

  function saveSelection() {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(selected)
    );
  }

  function normalize(value) {
    const clean = String(value || '').trim();
    return clean || '—';
  }

  function escapeHtml(value) {
    const div = document.createElement('div');

    div.textContent = String(value || '');

    return div.innerHTML;
  }

  /* ==========================================================
     PRODUTO A PARTIR DO BOTÃO COMPARAR
     ========================================================== */

  function productFromButton(button) {
    return {
      id: String(
        button.dataset.pdCompareId || ''
      ),

      group: String(
        button.dataset.pdCompareGroup || ''
      ),

      title: String(
        button.dataset.pdCompareTitle || ''
      ),

      url: String(
        button.dataset.pdCompareUrl || ''
      ),

      vendor: String(
        button.dataset.pdCompareVendor || ''
      ),

      price: String(
        button.dataset.pdComparePrice || ''
      ),

      image: String(
        button.dataset.pdCompareImage || ''
      ),

      screenSize: String(
        button.dataset.pdCompareScreenSize || ''
      ),

      resolution: String(
        button.dataset.pdCompareResolution || ''
      ),

      ram: String(
        button.dataset.pdCompareRam || ''
      ),

      storage: String(
        button.dataset.pdCompareStorage || ''
      ),

      network: String(
        button.dataset.pdCompareNetwork || ''
      ),

      battery: String(
        button.dataset.pdCompareBattery || ''
      ),

      /* Equipamentos básicos */
      camera: String(
        button.dataset.pdCompareCamera || ''
      ),

      connectivity: String(
        button.dataset.pdCompareConnectivity || ''
      ),

      extras: String(
        button.dataset.pdCompareExtras || ''
      )
    };
  }

  function findIndexById(id) {
    return selected.findIndex(function (item) {
      return String(item.id) === String(id);
    });
  }

  function sameGroup(product) {
    if (selected.length === 0) {
      return true;
    }

    const existingGroup =
      String(selected[0].group || '');

    const newGroup =
      String(product.group || '');

    /*
      Se não houver grupo disponível,
      permite comparar.
    */
    if (!existingGroup || !newGroup) {
      return true;
    }

    return existingGroup === newGroup;
  }

  /* ==========================================================
     UI GLOBAL
     ========================================================== */

  function ensureUi() {
    /* --------------------------------------------------------
       BARRA INFERIOR
       -------------------------------------------------------- */

    if (!document.querySelector('.pd-comparator-bar')) {
      document.body.insertAdjacentHTML(
        'beforeend',
        `
          <div class="pd-comparator-bar" aria-live="polite">

            <div class="pd-comparator-bar__left">

              <div class="pd-comparator-bar__count">
                0/4
              </div>

              <div class="pd-comparator-bar__text">
                <strong>
                  Comparar produtos
                </strong>

                <span>
                  Selecione até 4 modelos.
                </span>
              </div>

            </div>

            <div class="pd-comparator-bar__actions">

              <button
                type="button"
                class="pd-comparator-btn pd-comparator-btn--secondary"
                data-pd-clear-compare
              >
                LIMPAR
              </button>

              <button
                type="button"
                class="pd-comparator-btn pd-comparator-btn--primary"
                data-pd-open-compare
              >
                COMPARAR →
              </button>

            </div>

          </div>
        `
      );
    }

    /* --------------------------------------------------------
       MODAL
       -------------------------------------------------------- */

    if (!document.querySelector('.pd-comparator-modal')) {
      document.body.insertAdjacentHTML(
        'beforeend',
        `
          <div
            class="pd-comparator-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Comparação de produtos"
          >

            <div class="pd-comparator-modal__panel">

              <div class="pd-comparator-modal__header">

                <h2>
                  Comparar produtos
                </h2>

                <button
                  type="button"
                  class="pd-comparator-modal__close"
                  aria-label="Fechar comparação"
                  data-pd-close-compare
                >
                  ×
                </button>

              </div>

              <div class="pd-comparator-modal__body">

                <div class="pd-comparator-table-wrap">

                  <table class="pd-comparator-table">
                  </table>

                </div>

              </div>

            </div>

          </div>
        `
      );
    }

    /* --------------------------------------------------------
       TOAST
       -------------------------------------------------------- */

    if (!document.querySelector('.pd-comparator-toast')) {
      document.body.insertAdjacentHTML(
        'beforeend',
        `
          <div
            class="pd-comparator-toast"
            role="status"
          ></div>
        `
      );
    }
  }

  function toast(message) {
    const el =
      document.querySelector(
        '.pd-comparator-toast'
      );

    if (!el) {
      return;
    }

    el.textContent = message;

    el.classList.add(
      'is-visible'
    );

    window.clearTimeout(
      el._pdTimer
    );

    el._pdTimer =
      window.setTimeout(
        function () {
          el.classList.remove(
            'is-visible'
          );
        },
        2200
      );
  }

  /* ==========================================================
     SINCRONIZAÇÃO DOS BOTÕES
     ========================================================== */

  function updateButtons() {
    document
      .querySelectorAll('.pd-compare-button')
      .forEach(function (button) {

        const id =
          button.dataset.pdCompareId;

        const isSelected =
          findIndexById(id) !== -1;

        button.classList.toggle(
          'is-selected',
          isSelected
        );

        button.setAttribute(
          'aria-pressed',
          isSelected ? 'true' : 'false'
        );

        const text =
          button.querySelector(
            '.pd-compare-button__text'
          );

        const plus =
          button.querySelector(
            '.pd-compare-button__plus'
          );

        if (text) {
          text.textContent =
            isSelected
              ? 'SELECIONADO'
              : 'COMPARAR';
        }

        if (plus) {
          plus.textContent =
            isSelected
              ? '✓'
              : '+';
        }

      });
  }

  function updateBar() {
    const bar =
      document.querySelector(
        '.pd-comparator-bar'
      );

    const count =
      document.querySelector(
        '.pd-comparator-bar__count'
      );

    const open =
      document.querySelector(
        '[data-pd-open-compare]'
      );

    if (!bar || !count || !open) {
      return;
    }

    count.textContent =
      selected.length + '/4';

    bar.classList.toggle(
      'is-visible',
      selected.length > 0
    );

    open.disabled =
      selected.length < 2;

    open.style.opacity =
      selected.length < 2
        ? '.45'
        : '1';

    open.style.cursor =
      selected.length < 2
        ? 'not-allowed'
        : 'pointer';
  }

  function syncUi() {
    updateButtons();
    updateBar();
  }

  /* ==========================================================
     SELEÇÃO
     ========================================================== */

  function toggleProduct(button) {
    const product =
      productFromButton(button);

    const existingIndex =
      findIndexById(product.id);

    /*
      Se já estiver selecionado,
      remove.
    */
    if (existingIndex !== -1) {
      selected.splice(
        existingIndex,
        1
      );

      saveSelection();
      syncUi();

      return;
    }

    /*
      Se mudar de categoria,
      reinicia a comparação.
    */
    if (!sameGroup(product)) {
      selected = [];

      toast(
        'A comparação foi reiniciada para esta categoria.'
      );
    }

    /*
      Máximo de 4 produtos.
    */
    if (selected.length >= MAX_PRODUCTS) {
      toast(
        'Pode comparar no máximo 4 produtos.'
      );

      return;
    }

    selected.push(product);

    saveSelection();
    syncUi();
  }

  function clearSelection() {
    selected = [];

    saveSelection();
    syncUi();
    closeModal();
  }

  /* ==========================================================
     CARACTERÍSTICAS POR TIPO DE EQUIPAMENTO
     ========================================================== */

  /*
    SMARTPHONES
  */
  const smartphoneRows = [

    {
      label: 'Preço',
      key: 'price',
      className: 'pd-comparator-price'
    },

    {
      label: 'Marca',
      key: 'vendor'
    },

    {
      label: 'Tamanho do ecrã',
      key: 'screenSize'
    },
{
  label: 'Câmara',
  key: 'camera'
},
    {
      label: 'Memória RAM',
      key: 'ram'
    },

    {
      label: 'Armazenamento',
      key: 'storage'
    },

    {
      label: 'Rede de dados',
      key: 'network'
    },

    {
      label: 'Bateria',
      key: 'battery'
    }

  ];


  /*
    EQUIPAMENTOS BÁSICOS
  */
  const basicRows = [

    {
      label: 'Preço',
      key: 'price',
      className: 'pd-comparator-price'
    },

    {
      label: 'Marca',
      key: 'vendor'
    },

    {
      label: 'Ecrã',
      key: 'screenSize'
    },

    {
      label: 'Câmara',
      key: 'camera'
    },

    {
      label: 'Conectividade',
      key: 'connectivity'
    },

    {
      label: 'Bateria',
      key: 'battery'
    },

    {
      label: 'Extras',
      key: 'extras'
    }

  ];

  /* ==========================================================
     IDENTIFICAR O TIPO DE PRODUTO
     ========================================================== */

  function cleanGroupName(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(
        /[\u0300-\u036f]/g,
        ''
      );
  }

  function isBasicProduct(product) {
    const group =
      cleanGroupName(
        product.group
      );

    /*
      Primeiro tentamos identificar
      através da coleção.
    */
    if (
      group.includes('basico') ||
      group.includes('basic')
    ) {
      return true;
    }

    /*
      Segurança adicional:
      se tiver campos típicos dos básicos
      e não tiver RAM/armazenamento,
      consideramos equipamento básico.
    */
    const hasBasicFields =
      String(
        product.camera || ''
      ).trim() !== ''
      ||
      String(
        product.connectivity || ''
      ).trim() !== ''
      ||
      String(
        product.extras || ''
      ).trim() !== '';

    const hasSmartphoneFields =
      String(
        product.ram || ''
      ).trim() !== ''
      ||
      String(
        product.storage || ''
      ).trim() !== '';

    return (
      hasBasicFields &&
      !hasSmartphoneFields
    );
  }

  function rowsForCurrentSelection() {
    if (
      selected.length > 0 &&
      isBasicProduct(
        selected[0]
      )
    ) {
      return basicRows;
    }

    return smartphoneRows;
  }

  /* ==========================================================
     CABEÇALHO DA TABELA
     ========================================================== */

  function buildHeaderCell(product) {
    const image =
      product.image
        ? `
          <img
            class="pd-comparator-product-head__image"
            src="${escapeHtml(product.image)}"
            alt="${escapeHtml(product.title)}"
          >
        `
        : '';

    return `
      <th class="pd-comparator-product-head">

        ${image}

        <span
          class="pd-comparator-product-head__title"
        >
          ${escapeHtml(product.title)}
        </span>

        ${
          product.vendor
            ? `
              <span
                class="pd-comparator-product-head__vendor"
              >
                ${escapeHtml(product.vendor)}
              </span>
            `
            : ''
        }

      </th>
    `;
  }

  /* ==========================================================
     CONSTRUIR TABELA
     ========================================================== */

  function buildTable() {
    const table =
      document.querySelector(
        '.pd-comparator-table'
      );

    if (!table) {
      return;
    }

    let html =
      '<thead><tr><th>Equipamento</th>';

    /*
      Cabeçalho de cada produto.
    */
    selected.forEach(
      function (product) {
        html +=
          buildHeaderCell(product);
      }
    );

    html +=
      '</tr></thead><tbody>';

    /*
      Decide se mostra características
      de smartphone ou de básico.
    */
    const rows =
      rowsForCurrentSelection();

    /*
      Linhas da comparação.
    */
    rows.forEach(
      function (row) {

        html += `
          <tr>
            <td>
              ${escapeHtml(row.label)}
            </td>
        `;

        selected.forEach(
          function (product) {

            const value =
              normalize(
                product[row.key]
              );

            html += `
              <td>

                <span
                  class="${
                    row.className ||
                    'pd-comparator-value'
                  }"
                >
                  ${escapeHtml(value)}
                </span>

              </td>
            `;

          }
        );

        html +=
          '</tr>';
      }
    );

    /*
      Linha final — botão Ver Produto.
    */
    html +=
      '<tr><td>Produto</td>';

    selected.forEach(
      function (product) {

        html += `
          <td>

            <a
              class="pd-comparator-product-link"
              href="${escapeHtml(product.url)}"
            >
              VER PRODUTO →
            </a>

          </td>
        `;

      }
    );

    html +=
      '</tr></tbody>';

    table.innerHTML = html;
  }

  /* ==========================================================
     MODAL
     ========================================================== */

  function openModal() {
    if (selected.length < 2) {
      toast(
        'Selecione pelo menos 2 produtos.'
      );

      return;
    }

    buildTable();

    const modal =
      document.querySelector(
        '.pd-comparator-modal'
      );

    if (!modal) {
      return;
    }

    modal.classList.add(
      'is-open'
    );

    document.documentElement.style.overflow =
      'hidden';
  }

  function closeModal() {
    const modal =
      document.querySelector(
        '.pd-comparator-modal'
      );

    if (!modal) {
      return;
    }

    modal.classList.remove(
      'is-open'
    );

    document.documentElement.style.overflow =
      '';
  }

  /* ==========================================================
     EVENTOS
     ========================================================== */

  document.addEventListener(
    'click',
    function (event) {

      /*
        Botão COMPARAR do produto.
      */
      const compareButton =
        event.target.closest(
          '.pd-compare-button'
        );

      if (compareButton) {
        event.preventDefault();
        event.stopPropagation();

        toggleProduct(
          compareButton
        );

        return;
      }

      /*
        Abrir comparador.
      */
      if (
        event.target.closest(
          '[data-pd-open-compare]'
        )
      ) {
        openModal();
        return;
      }

      /*
        Limpar.
      */
      if (
        event.target.closest(
          '[data-pd-clear-compare]'
        )
      ) {
        clearSelection();
        return;
      }

      /*
        Fechar.
      */
      if (
        event.target.closest(
          '[data-pd-close-compare]'
        )
      ) {
        closeModal();
        return;
      }

      /*
        Clique no fundo escuro.
      */
      const modal =
        event.target.closest(
          '.pd-comparator-modal'
        );

      if (
        modal &&
        event.target.classList.contains(
          'pd-comparator-modal'
        )
      ) {
        closeModal();
      }

    }
  );

  /*
    ESC fecha o comparador.
  */
  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key === 'Escape') {
        closeModal();
      }

    }
  );

  /* ==========================================================
     ARRANQUE
     ========================================================== */

  function init() {
    ensureUi();

    loadSelection();

    syncUi();
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }

})();